import { clsx } from "clsx";
import EditIcon from "../../icons/edit.svg";

function ReasonInPlay(props) {
	const style = {
		button: {
			base: "px-4 py-2 font-bold text-white rounded-lg cursor-pointer",
			moveCG: "bg-green-500 hover:bg-green-700",
			moveDS: "bg-red-500 hover:bg-red-700",
		},
		controls: "absolute top-2 right-2",
		icon: {
			button: "p-1 border border-black/50 rounded-md w-[28px] cursor-pointer",
			edit: "hover:bg-slate-300",
		},
		reasonType: "font-semibold text-xl",
		reasonText: "text-lg"
	};

	const reasonType = props.reason.type === "for" ? "For" : props.reason.type === "against" ? "Against" : "For/Against";

	const didVoteEstablished = props.reason.established.includes(props.player.id);
	const didVoteContested = props.reason.contested.includes(props.player.id);
	const didVoteNonGermane = props.reason.nonGermane.includes(props.player.id);

	function triggerOpenEditReasonForm() {
		props.openEditReasonForm("rip");
	}

	function voteEstablished(playerId) {
		props.handleEstablished(playerId);
	}

	function voteContested(playerId) {
		props.handleContested(playerId);
	}

	// function voteNonGermane(playerId) {
	// 	props.handleNonGermane(playerId);
	// }

	function openConfirmationModal(type) {
		const action = {
			type: type,
		}
		props.openConfirmActionModal(action);
	}

	return (
		<div className="relative lg:w-4/6 w-full mt-1 mr-1 mb-1 flex flex-col items-center justify-between border rounded-md">
			<h2 className="text-2xl font-bold text-gray-800">Reason-in-Play</h2>
			{props.role === "referee" || props.reason.playerId === props.player.id ? 
				(
					<div className={style.controls}>
						<button aria-label="Edit Reason" className={`${style.icon.button} ${style.icon.edit}`} onClick={triggerOpenEditReasonForm}>
							<EditIcon />
						</button>
					</div>
				) : null}
			<div className="mx-6 flex flex-col h-4/5 items-center gap-y-6">
				<div className={style.reasonType}>{reasonType}</div>
				<div className={style.reasonText}>{props.reason.reason}</div>
				<div className="flex justify-center gap-6">
					{props.role === "player" ? (
						<>
							<button
								aria-label="Established"
								onClick={() => voteEstablished(props.player.id)}
								className={clsx(style.button.base,
									!didVoteEstablished && "bg-true-blue/80 hover:bg-true-blue",
									didVoteEstablished && "bg-gray-600 ring-2 ring-true-blue"
								)}>
								Established
							</button>
							<button
								aria-label="Contested"
								onClick={() => voteContested(props.player.id)}
								className={clsx(style.button.base,
									!didVoteContested && "bg-primary-red/80 hover:bg-primary-red",
									didVoteContested && "bg-gray-600 ring-2 ring-primary-red"
								)}>
								Contested
							</button>
							{/* <button
								aria-label="Non-Germane"
								onClick={() => voteNonGermane(props.player.id)}
								className={clsx(style.button.base,
									!didVoteNonGermane && "bg-neutral-gray/80 hover:bg-neutral-gray",
									didVoteNonGermane && "bg-gray-600 ring-2 ring-neutral-gray"
								)}>
								Non-Germane
							</button> */}
						</>
					) : null}

					{props.role === "referee" ? (
						<>
							<button aria-label="Common Ground" className={clsx(style.button.base, style.button.moveCG)} onClick={ () => openConfirmationModal('moveCG')}>
								Common Ground
							</button>
							<button aria-label="End Bout" className={clsx(style.button.base, style.button.moveDS)} onClick={ () => openConfirmationModal('moveDS')}>
								End Bout
							</button>
						</>
					) : null}
					
				</div>
			</div>
		</div>
	);
}

export default ReasonInPlay;
